module.exports = __webpack_public_path__ + "static/media/deleteiconblack.208d4b7c.svg";